import { render, staticRenderFns } from "./index.vue?vue&type=template&id=5b5848ad&scoped=true&"
import script from "./index.vue?vue&type=script&lang=ts&"
export * from "./index.vue?vue&type=script&lang=ts&"
import style0 from "./index.vue?vue&type=style&index=0&id=5b5848ad&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b5848ad",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\opusb-web-myactio\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b5848ad')) {
      api.createRecord('5b5848ad', component.options)
    } else {
      api.reload('5b5848ad', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=5b5848ad&scoped=true&", function () {
      api.rerender('5b5848ad', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/app/layout/components/Settings/index.vue"
export default component.exports